import { render, staticRenderFns } from "./order-priority-select.vue?vue&type=template&id=41da4433&"
import script from "./order-priority-select.vue?vue&type=script&lang=js&"
export * from "./order-priority-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports